/**
 * ProduktlyIntegration.ts
 * 
 * This file manages the integration with Produktly for user identification
 * and other Produktly-related functionality.
 */

/**
 * Identifies the user to Produktly with their unique ID and relevant metadata
 * 
 * @param userId - Unique identifier for the user
 * @param userData - User data object containing additional metadata
 */
export const identifyProduktlyUser = (userId: string | number, userData: any) => {
  // Create metadata object with user information
  const metadata = {
    email: userData?.user?.email,
    firstName: userData?.user?.first_name,
    lastName: userData?.user?.last_name,
    createdAt: userData?.user?.created_at || new Date().toISOString()
  };

  // Check if Produktly is loaded
  if (window.Produktly) {
    // If Produktly is already loaded, identify user immediately
    window.Produktly.identifyUser(userId, metadata);
  } else {
    // If Produktly isn't loaded yet, use window.onload as demonstrated in the example
    window.onload = () => {
      window.Produktly.identifyUser(userId, metadata);
    };
  }
}; 